import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import { CardsSection } from "@shared/uiNew/CardsSection"

import markerAnimation from "@shared/animations/animation_7.json"

import * as styles from "../styles.module.scss"

const Dialog = (props) => (
  <CardsSection
    title="Вы полностью "
    titleTail="контролируете качество диалогов"
    description="Инструменты для руководителя — чтобы видеть все и улучшать постоянно."
    className={styles.dialogCards}
    bgColor="#F9F9F9"
    columns={4}
    markerAnimationData={markerAnimation}
    classNameMarker={styles.dialogMarker}
    items={dialogArray.map((item, i) => ({
      img: item.img,
      title: item.title,
      text: item.description,
      imageMode: "inline",
    }))}
    buttonProps={{
      text: "Оставить заявку на демо",
      icon: "arrow",
      style: styles.buttonSupport,
    }}
  />
)

export default Dialog

const dialogArray = [
  {
    img: <StaticImage objectFit="contain" objectPosition="left" src="../assets/bullet_6.png" alt="Контроль операторов" width={120} placeholder="none" />,
    title: "Контроль операторов",
    description:
      "Отслеживайте медианное время ответа, соблюдение SLA и загруженность каждого сотрудника. Экспортируйте данные в ваши BI-системы для построения сквозной аналитики по всему отделу",
  },
  {
    img: <StaticImage objectFit="contain" objectPosition="left" src="../assets/bullet_7.png" alt="Оценки и обратная связь" width={120} placeholder="none" />,
    title: "Оценки и обратная связь",
    description: "Клиенты оценивают диалоги после завершения. Вы видите, кто из операторов работает хорошо, а где нужно подтянуть качество.",
  },
  {
    img: <StaticImage objectFit="contain" objectPosition="left" src="../assets/bullet_8.png" alt="Аудит диалогов" width={120} placeholder="none" />,
    title: "Аудит диалогов",
    description: "Все диалоги сохраняются. Проверьте любой разговор в любой момент — и скорректируйте скрипты или базу знаний бота.",
  },
  {
    img: <StaticImage objectFit="contain" objectPosition="left" src="../assets/bullet_9.png" alt="Маршрутизация диалогов" width={120} placeholder="none" />,
    title: "Маршрутизация диалогов",
    description:
      "Задайте правила: какой диалог идет в поддержку, какой — в продажи, какой сразу к конкретному оператору. По теме, каналу или сегменту клиента.",
  },
]
